/**
 * src/lib/api/timelog.js — Time log read/write API.
 * Returns raw snake_case Supabase rows. See docs/SHAPE_CONTRACT.md.
 */

import { supabase } from '../supabase';

export async function fetchTimeLog(filters = {}) {
  try {
    let query = supabase.from('time_logs').select('*').order('date', { ascending: false });

    if (filters.project_id) query = query.eq('project_id', filters.project_id);
    if (filters.person_id) query = query.eq('person_id', filters.person_id);
    if (filters.from) query = query.gte('date', filters.from);
    if (filters.to) query = query.lte('date', filters.to);

    const { data, error } = await query;
    if (error) { console.warn('[timelog] fetch error:', error.message); return []; }
    return data || [];
  } catch (err) {
    console.warn('[timelog] fetchTimeLog failed:', err.message);
    return [];
  }
}

export async function createTimeEntry(payload, { signal } = {}) {
  const row = {
    date: payload.date,
    duration_hours: payload.duration_hours != null ? parseFloat(payload.duration_hours) : null,
    person_id: payload.person_id || null,
    project_id: payload.project_id || null,
    task_id: payload.task_id || null,
    bundle_id: payload.bundle_id || null,
    work_type: payload.work_type || null,
    notes: payload.notes || null,
  };

  if (signal?.aborted) return { success: false, error: 'Request was cancelled' };

  const { data, error } = await supabase.from('time_logs').insert(row).select().single();

  if (signal?.aborted) return { success: false, error: 'Request was cancelled' };

  if (error) return { success: false, error: error.message };
  return { success: true, record: data };
}
